import useI18nGlobal from '@/utils/i18n';
const {i18n} = useI18nGlobal();
const {t} = i18n.global;
export const BORDER_STYLE = [
  {value: 'dotted', get name() {return t('options.style.dotted')}},
  {value: 'solid', get name() {return t('options.style.solid')}},
  {value: 'dashed', get name() {return t('options.style.dashed')}}
];